/* eslint-disable react/prop-types */
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

import useOrbitFlag from '../../../../hooks/useOrbitFlag'
import { VENDOR_NAVLINKS } from '../navlinks'

import { AppMenuAccordion, AppMenuItem } from './components/NavbarMenu'
import NavBarToolTip from './components/NavbarTooltip'

const SubMenuItem = ({ sublink, role, variant }) => {
  const sublinkFlag = useOrbitFlag(sublink.flag)

  // Render the item only if the user group matches and the feature flag is active
  if (!sublink.userGroups.includes(role) || (sublink.flag && !sublinkFlag)) {
    return null
  }

  return (
    <AppMenuItem
      key={sublink.title}
      as={RouterLink}
      to={sublink.to}
      indent={1}
      variant={variant}
      data-cy={`${sublink.to}-submenu`}
      sx={{
        fontSize: '14px !important', 
        color: 'black !important', // Ensure text color is black
        backgroundColor: '#E6F0FA', // A light grey for sub-items
        '&:hover': {
          backgroundColor: '#B3D1FA' // Darker on hover
        }
      }}
    >
      <span
        id={
          sublink.title.indexOf(' ') >= 0
            ? sublink.title.split(' ').join('_')
            : sublink.title
        }
      >
        {sublink.title}
      </span>
    </AppMenuItem>
  )
}

const NavLink = ({ link, role, toggled, variant }) => {
  const linkFlag = useOrbitFlag(link.flag)
  // if the side nav is toggled open, show the full menu
  if (link.userGroups.includes(role) && linkFlag) {
    if (toggled) {
      return (
        // provide nested links
        link.sub.length > 0 ? (
          <AppMenuAccordion
            key={link.title}
            as={RouterLink}
            title={link.title}
            to={link.to}
            data-cy={link.to}
          >
            {link.sub.map((sublink) => (
              <SubMenuItem
                key={sublink.title}
                sublink={sublink}
                role={role}
                variant={variant}
              />
            ))}
          </AppMenuAccordion>
        ) : (
          <AppMenuItem
            as={RouterLink}
            key={link.title}
            to={link.to}
            variant={variant}
            data-cy={link.to}
          >
            <span
              id={
                link.title.indexOf(' ') >= 0
                  ? link.title.split(' ').join('_')
                  : link.title
              }
            >
              {link.title}
            </span>
          </AppMenuItem>
        )
      )
    } else {
      return (
        // if toggled close, display tooltips and a representative logo
        <AppMenuItem as={RouterLink} to={link.to} key={link.title}>
          <NavBarToolTip title={link.title} placement='right'>
            {link.tooltip}
          </NavBarToolTip>
        </AppMenuItem>
      )
    }
  } else {
    return null
  }
}

function NavLinks({ role, toggled }) {
  const activeTabVariant = ['opsowner', 'ops'].includes(role)
    ? 'secondary'
    : 'primary'
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', overflowY: 'scroll' }}>
      {['opsowner', 'ops', 'opsviewer', 'external'].includes(role) &&
        VENDOR_NAVLINKS.map((link) => (
          <NavLink
            key={link.title}
            link={link}
            role={role}
            toggled={toggled}
            variant={activeTabVariant}
          />
        ))}
    </Box>
  )
}

NavLinks.propTypes = {
  role: PropTypes.string,
  toggled: PropTypes.bool
}
export default NavLinks
